var _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMac({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    height: "32px",
    id: "Layer_1",
    viewBox: "0 0 32 32",
    width: "32px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M28.955,22.814v-0.218c-2.624-1.399-4.048-3.453-4.048-6.426   c0-2.404,1.068-4.503,3.025-5.857l0.089-0.044c-1.29-1.573-3.025-3.146-5.694-3.146c-1.868,0-3.425,1.792-6.005,1.792   c-2.046,0-2.892-1.705-5.116-1.705c-4.626,0-9.208,4.065-9.208,9.354c0,2.798,0.934,7.126,3.025,10.885   c1.513,2.754,3.381,4.546,5.472,4.546c1.512,0,3.291-1.355,5.427-1.355c1.868,0,3.604,1.225,5.293,1.225   c4.049,0,7.785-5.158,7.785-8.61C29,23.077,28.955,22.946,28.955,22.814z",
    fill: "#CCCCCC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16.229,8.349c3.025-0.918,5.828-3.148,5.828-7.038   c0-0.306-0.044-0.699-0.089-1.136L21.924,0c-3.069,0.829-5.827,3.19-5.827,6.906c0,0.35,0.045,0.787,0.133,1.268V8.349z",
    fill: "#CCCCCC",
    fillRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMac);
export default __webpack_public_path__ + "static/media/mac.a0387718392ed4ff60794695eed0e3a6.svg";
export { ForwardRef as ReactComponent };